// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"SurveyCheckboxes_fullWidth__AKzUX","lastChildBorder":"SurveyCheckboxes_lastChildBorder__j01d7"};